import {Injectable} from '@angular/core';

import * as io from 'socket.io-client';
import {AuthService} from './auth.service';
import {environment} from '../../environments/environment';

export interface INotification {
    type: string;
    payload: any;
}

@Injectable()
export class SocketService {
    public socket: any;

    constructor(private authService: AuthService) {
    }

    connect() {
        if (!environment.isWebSocketEnabled) {
            return;
        }
        this.socket = io.connect(environment.baseUrl.webSocketServer.main, {
            transports: ['websocket']
        });
        this._authenticate();
    }

    public get connection(): Promise<any> {
        if (!environment.isWebSocketEnabled) {
            return Promise.resolve(this.noopSocket);
        }
        return new Promise((resolve) => {
            if (this.socket) {
                return resolve(this.socket);
            }
            this.socket = io.connect(environment.baseUrl.webSocketServer.main, {
                transports: ['websocket']
            });
            this._authenticate();
            resolve(this.socket);
        });
    }

    private _authenticate() {
        this.socket.emit('auth', {token: this.authService.token, origin: environment.baseUrl.backend.main});
    }

    public get noopSocket() {
        return {
            on: (event: string, cb: () => void) => {
            }
        };
    }
}
